export default __webpack_public_path__ + "static/media/hero-banner.25813faa.png";